// Make all numbers in object to strings. (API need numbers as strings)
// Input:
// {
//    name: 'Adam',
//    age: 15
// }
// Output:
// {
//    name: 'Adam',
//    age: '15'
// }
export const convertObjectNumbersToString = (object: Object) => {
  Object.keys(object).forEach((k) => {
    if (typeof object[k] === 'number') {
      return (object[k] = object[k].toString())
    }
  })

  return object
}
